import React from 'react';
import cbcvLogo from '../assets/logo2016cuadrado_sinfondo.png';

const HomePage = () => (
  <div className="not-found-wrapper">
    <img src={cbcvLogo} alt="Colegio Bilingue Ciudad Vieja Logo" />
    <h4> Bienvenido a Colegio Bilingue Ciudad Vieja </h4>
  </div>
);

export default HomePage;



// WEBPACK FOOTER //
// ./src/containers/HomePage.js